import { Button } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { useVerifyAsset } from '../../api';

const { t } = I18n;

const TRANSLATED_VERIFY = t('js.admin.cms.dashboard_table.actions.verify');

export const CMSAssetVerifyButton = ({ cmsAssetId }: { cmsAssetId: string }) => {
  const verifyAsset = useVerifyAsset(cmsAssetId);
  return (
    <Button
      variant="text"
      onPress={() => {
        verifyAsset.mutate(cmsAssetId);
      }}
      isDisabled={verifyAsset.isLoading}
    >
      {TRANSLATED_VERIFY}
    </Button>
  );
};
